import { AppButton } from "@libs/zapi-ui/custom";

export function DiffButtons({
  accept,
  discard,
  type
}: {
  accept: () => void;
  discard: () => void;
  type: "add" | "del";
}) {
  const acceptText = type === "add" ? "Add" : "Remove";
  const discardText = type === "add" ? "Don't Add" : "Don't Remove";
  return (
    <span className="absolute bottom-1 right-1 flex gap-1 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:pointer-events-auto transition-opacity">
      <AppButton
        data-testid="diff-accept-button"
        size="sm"
        onClick={accept}
        className=" bg-green-500 hover:bg-green-600 text-white text-[12px] leading-[18px] flex items-center justify-center rounded-md"
      >
        {acceptText}
      </AppButton>
      <AppButton
        data-testid="diff-discard-button"
        onClick={discard}
        size="sm"
        className=" bg-red-500 hover:bg-red-600 text-white text-[12px] leading-[18px] flex items-center justify-center rounded-md"
      >
        {discardText}
      </AppButton>
    </span>
  );
}
